import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { Tooltip } from '@blade/ui-kit'
import { NetworkIcon } from '@root/entities/network/ui'
import { PairFeeTooltipContent } from '@root/entities/pair/ui/pair-fee-tooltip-content'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { AmountFormatted } from '@root/shared/core/format'

import { PairInformationPoolItem } from './pair-information-pool-item'

import type { PairModel } from '@root/entities/pair/atoms'

type Props = {
  pair: PairModel
}

export const PairInformationFees: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()
  const [totalFees] = useAtom(pair.fees.totalFees)

  return (
    <Tooltip content={<PairFeeTooltipContent pair={pair} />}>
      <PairInformationPoolItem title={t('trade.pair-information.fees-paid')}>
        <FlashTextContentDistinct>
          <AmountFormatted amount={totalFees} />
        </FlashTextContentDistinct>
        <NetworkIcon size={12} network={pair.network} />
      </PairInformationPoolItem>
    </Tooltip>
  )
})
